// The tenant's WhatsApp message templates: the list (every role), creating
// one and syncing with Meta (owner and admin; the server refuses the rest).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, unwrap } from './client'
import type { components } from './generated/schema'

export type MessageTemplate = components['schemas']['MessageTemplate']
export type TemplateLibrary = components['schemas']['TemplateLibrary']
export type TemplateInput = components['schemas']['TemplateInput']
export type TemplateButtonInput = components['schemas']['TemplateButtonInput']
export type TemplateStatus = components['schemas']['TemplateStatus']

const templatesKey = ['templates'] as const

export function useTemplates() {
  return useQuery({
    queryKey: templatesKey,
    queryFn: async (): Promise<TemplateLibrary> => unwrap(await api.GET('/templates')),
  })
}

export function useCreateTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (body: TemplateInput) => unwrap(await api.POST('/templates', { body })),
    onSuccess: () => void qc.invalidateQueries({ queryKey: templatesKey }),
  })
}

export function useSyncTemplates() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (): Promise<TemplateLibrary> => unwrap(await api.POST('/templates/sync')),
    onSuccess: (lib) => qc.setQueryData(templatesKey, lib),
  })
}
